class EmployeeModel {

employeeId?: number;
  employeeCode?: string;
  name?: string;
  employeeTypeId?: number;
  employeeTypeName?: string;
  unionId?:number;
  unionName?:string;
  address?: string;
  city?: string;
  pincode?: string;
  droppingPointId?: number;
  droppingPointName?: string;
  employeePhotoPath?: string;
  panNumber?: string;
  aadharNumber?: string;
  rationcardNumber?: string;
  isActive?:boolean
 
}
export default EmployeeModel;
